import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-comm',
  templateUrl: './ticket-comm.component.html',
  styleUrls: ['./ticket-comm.component.css']
})
export class TicketCommComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
